/**
 * The phone catalog bar's count (_mobile-bar.blade.php) follows the list's: the
 * count the server rendered, or the map area's while the map's search drives the
 * list. CatalogMap.vue says which with `idx:area-count` — the number, or null to
 * go back to the page's own. The label stays "results", in the plural the number
 * takes (the same forms trans_choice() picks on the server).
 *
 * The bar is looked up when the count changes, not once: it sits inside the Vue
 * root, which renders its markup anew when it mounts.
 */
export function initIdxMobileBar() {
    let page = null;

    window.addEventListener('idx:area-count', (event) => {
        const bar = document.querySelector('.idx-mbar');

        if (!bar) {
            return;
        }

        const total = bar.querySelector('.idx-mbar__total');
        const label = bar.querySelector('.idx-mbar__label');
        const n = event.detail;

        // The page's own count, kept the first time the map's search replaces it.
        page = page || { total: total.textContent, label: label.textContent };

        if (n === null || n === undefined) {
            total.textContent = page.total;
            label.textContent = page.label;

            return;
        }

        // Grouped as number_format() prints the page's own count.
        total.textContent = Number(n).toLocaleString('en-US');
        label.textContent = window.transChoice('idx.catalog_bar.results', n);
    });
}
